import { jsx } from 'react/jsx-runtime';
import * as React from 'react';
import '../../utils/index_orig/index.esm.js';
import '../../utils/theme/theme-provider/index.esm.js';
import styles from '../../styles/uitk-egds-tabs.css';
import { classNames } from '../../utils/classnames/index.esm.js';
const getClassNameList = classNames.bind(styles);
class EGDSTab extends React.Component {
  static displayName = 'EGDSTab';
  parentDiv = React.createRef();
  render() {
    const {
      selected
    } = this.props;
    const wrapperClassNames = getClassNameList('uitk-tabs-pane', {
      [`active`]: selected
    });
    const {
      name,
      children,
      id
    } = this.props;
    return jsx("div", {
      ref: this.parentDiv,
      role: "tabpanel",
      className: wrapperClassNames,
      id: id,
      children: children
    }, name);
  }
}
export { EGDSTab };